import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SixDotsVerticalIcon = forwardRef<SVGSVGElement, IconProps>(function SixDotsVerticalIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 4.94118C3.44772 4.94118 3 5.41523 3 6C3 6.58477 3.44772 7.05882 4 7.05882C4.55228 7.05882 5 6.58477 5 6C5 5.41523 4.55228 4.94118 4 4.94118Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M4 9.88235C3.44772 9.88235 3 10.3564 3 10.9412C3 11.5259 3.44772 12 4 12C4.55228 12 5 11.5259 5 10.9412C5 10.3564 4.55228 9.88235 4 9.88235Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M4 0C3.44772 0 3 0.474051 3 1.05882C3 1.6436 3.44772 2.11765 4 2.11765C4.55228 2.11765 5 1.6436 5 1.05882C5 0.474051 4.55228 0 4 0Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8 4.94118C7.44772 4.94118 7 5.41523 7 6C7 6.58477 7.44772 7.05882 8 7.05882C8.55228 7.05882 9 6.58477 9 6C9 5.41523 8.55228 4.94118 8 4.94118Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8 9.88235C7.44772 9.88235 7 10.3564 7 10.9412C7 11.5259 7.44772 12 8 12C8.55228 12 9 11.5259 9 10.9412C9 10.3564 8.55228 9.88235 8 9.88235Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8 0C7.44772 0 7 0.474051 7 1.05882C7 1.6436 7.44772 2.11765 8 2.11765C8.55228 2.11765 9 1.6436 9 1.05882C9 0.474051 8.55228 0 8 0Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
